import React, { Component } from 'react';

import classNames from 'classnames';
import { Radio } from 'components/cosmos';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './RadiolistItem.scss';

class RadiolistItem extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    formatItem: PropTypes.func,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    id: PropTypes.string,
    item: PropTypes.object,
    name: PropTypes.string
  };

  render() {
    const {
      id,
      name,
      className,
      item,
      checked,
      formatItem,
      onChange,
      onClick
    } = this.props;
    const classComponent = classNames('radiolist__item', className);
    const labelValue = formatItem ? formatItem(item) : item.name;

    return item && item.type ? (
      this.renderHeadingItem(item, classComponent)
    ) : (
      <li className={classComponent}>
        <Radio
          id={id}
          name={name}
          value={item.value}
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          label={labelValue}
        />
        {item.description && (
          <p className="radiolist__item__description secondary">
            {item.description}
          </p>
        )}
      </li>
    );
  }

  renderHeadingItem(item, classComponent) {
    // eslint-disable-next-line
    const { type, amount, value, ...props } = item;
    const headingClass = classNames(`radiolist__item--${type}`, classComponent);

    return (
      <li className={headingClass}>
        {Object.keys(props).map((key, index) => (
          <span key={index}>
            <I18n label={props[key]} amount={amount} />
          </span>
        ))}
      </li>
    );
  }
}

export default RadiolistItem;
